export default "__VITE_ASSET__CBoYIMWh__"